import { LOCATION_CHANGE } from "react-router-redux";
import browserHistory from "web_modules/redux/history";
import { getSessionToken, tokenHasRoles } from "web_modules/shared/session";
import { ResourceToRoles } from "@eave/shared/types/api";

// eslint-disable-next-line consistent-return
const routeRole = () => next => action => {
  if (action.type !== LOCATION_CHANGE || !getSessionToken()) {
    return next(action);
  }

  const {
    payload: { pathname },
  } = action;

  const firstResource = pathname.split("/")[1];
  const roles = ResourceToRoles[firstResource];

  // if we found the roles for the resource and they don't have permission
  // send to 404 page otherwise advance
  if (roles && !tokenHasRoles(getSessionToken(), ...roles)) {
    browserHistory.push("/404");
  }

  return next(action);
};

export default routeRole;
